module.exports = __webpack_public_path__ + "static/media/chet_faker_1.88a6e057.jpg";